import React from "react";

interface V2AttachmentIconProps {
  size?: number;
  className?: string;
}

/** 输入栏附件按钮 — 圆环 + 号 */
const V2AttachmentIcon: React.FC<V2AttachmentIconProps> = ({
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    className={className}
    aria-hidden
  >
    <circle cx="12" cy="12" r="9.25" />
    <path d="M12 8.5v7" />
    <path d="M8.5 12h7" />
  </svg>
);

export default V2AttachmentIcon;
